// extracted by mini-css-extract-plugin
module.exports = {"uploadedImageContainer":"uploadedImage_uploadedImageContainer__2OXAO","iconStyle":"uploadedImage_iconStyle__1YHZl"};